<template>
    <div class="bottom"></div>
</template>

<script>
export default {
    name: 'headtitle.temhead7'
}
</script>

<style lang="scss" scoped>
.bottom {
    width: 100%;
    height: 54px;
    margin-top: auto;
    background: url(@/assets/temimg15/bottom.png) no-repeat;
    background-size: 100% 100%;
    z-index: 400;
    position: absolute;
    bottom: 0;
}
</style>